import React, { Component } from 'react';
import * as Styles from './Styles';
import SvgPdf from '../../../others/svg_dist/Pdf';

type Props = {};

type State = {};

class Schemas extends Component<Props, State> {
	state = {};

	downloadFile = (url: string) => {
		const tempAnchor = document.createElement('a');
		tempAnchor.href = url;
		tempAnchor.target = '_blank';
		tempAnchor.click();
	};

	render() {
		return (
			<Styles.Wrapper>
				<Styles.HeadingFont>zgłoszenie szkody</Styles.HeadingFont>
				<Styles.HeadingLowerFont>
					wypadek ubezpieczeniowy można zgłosić na różne sposoby
				</Styles.HeadingLowerFont>
				<Styles.ContentContainer>
					<Styles.CardsContainerBackgroundDecor />
					<Styles.CardsContainer>
						<Styles.Card>
							<Styles.CardHeadingContainer>
								<p>ubezpieczenie OC</p>
								<p>kosztów ochrony prawnej NNW</p>
								<Styles.CardHeadingEmailContainer></Styles.CardHeadingEmailContainer>
							</Styles.CardHeadingContainer>
							<p style={{ marginBottom: '0px' }}>
								mailowo wysyłając wiadomość na adres:
							</p>
							<a href="mailto:brokerszkody@ergohestia.pl">
								<p style={{ margin: '4px 20px' }}>
									brokerszkody@ergohestia.pl
								</p>
							</a>
							<p style={{ marginTop: '0px' }}>
								wraz z wypełnionym formularzem zgłoszenia szkody
							</p>
							<Styles.CardDivider />
							<p style={{ marginBottom: '6px' }}>
								telefonicznie pod nr infolinii STU ERGO Hestia:
							</p>
							<p style={{ marginTop: '0px' }}>
								<a href="tel:801 107 107">801 107 107</a> lub{' '}
								<a href="tel:58 555 55 55">58 555 55 55</a>
							</p>
							<Styles.CardDivider />
							<p>
								<span>WAŻNE</span>
							</p>
							<p>
								Zanotuj jakie dokumenty należy dosłać i
								następnie prześlij ja na adres e-mail:{' '}
								<a href="mailto:brokerszkody@ergohestia.pl">
									brokerszkody@ergohestia.pl
								</a>
							</p>
							<p>
								Dokumentów przesłanych mailowo nie trzeba
								dodatkowo wysyłać pocztą tradycyjną.
							</p>
							<p>
								Pozostałe formy kontaktu z ERGO Hestią
								znajdziesz{' '}
								<a href="https://www.ergo-hestia-warszawa.pl/zgloszenie-szkody">
									tutaj
								</a>
								.
							</p>
							<Styles.CardDownloadSection>
								<Styles.CardDownloadButton
									onClick={() =>
										this.downloadFile(
											'/downloads/formularz-zgloszenia-szkody-oc.pdf'
										)
									}
								>
									<SvgPdf />
									<p>pobierz formularz</p>
									<p>OC i koszty ochrony prawnej</p>
								</Styles.CardDownloadButton>
								<Styles.CardDownloadButton
									onClick={() =>
										this.downloadFile(
											'/downloads/formularz-zgloszenia-wypadku-nnw.pdf'
										)
									}
								>
									<SvgPdf />
									<p>pobierz formularz</p>
									<p>NNW</p>
								</Styles.CardDownloadButton>
							</Styles.CardDownloadSection>
						</Styles.Card>
						<Styles.Card>
							<Styles.CardHeadingContainer>
								<p>Assistance Medyczny</p>
								<Styles.CardHeadingEmailContainer></Styles.CardHeadingEmailContainer>
							</Styles.CardHeadingContainer>
							<p style={{ marginBottom: '0px' }}>
								telefonicznie pod nr Centrum Alarmowego:
							</p>
							<p style={{ marginTop: '6px' }}>
								<a href="tel:22 522 29 90">22 522 29 90</a> lub{' '}
								<a href="tel:22 232 29 90">22 232 29 90</a>
							</p>
							<Styles.CardDivider />
							<p style={{ marginBottom: '0px' }}>
								mailowo wysyłając wiadomość na adres:
							</p>
							<a href="mailto:pms.szkody@mondial-assistance.pl">
								<p style={{ marginTop: '6px' }}>
									pms.szkody@mondial-assistance.pl
								</p>
							</a>
							<Styles.CardDivider />
							<p style={{ position: 'absolute', bottom: '0' }}>
								Pozostałe formy kontaktu z ERGO Hestią
								znajdziesz{' '}
								<a href="https://www.ergo-hestia-warszawa.pl/zgloszenie-szkody">
									tutaj
								</a>
								.
							</p>
						</Styles.Card>
					</Styles.CardsContainer>
				</Styles.ContentContainer>
			</Styles.Wrapper>
		);
	}
}

export default Schemas;
